import { UserModel } from './user.state';

export class SetUser {
  static readonly type = '[Auth] SetUser';
  constructor(public user: UserModel | null) {}
}
export class SetAuthToken {
  static readonly type = '[Auth] SetAuthToken';
  constructor(public authToken: string | null) {}
}
export class UnsetUser {
  static readonly type = '[Auth] UnsetUser';
  constructor() {}
}
